import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import util from "@/libs/util.js";
import dayjs from "dayjs";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  name: "house-auth",
  mixins: [userPopMixin],
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        status: 0,
        // 全部：0  已认证：1 ， 已过期： 2，已失效：3
        role: 0,
        // 全部：0  房东：1   房东家人：5   转租：3  商业：4
        phone: this.$route.query.phone || "",
        userName: "",
        authUserName: "",
        address: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      remarkDialogVisible: false,
      currentRemarkObj: {},
      filterList: {
        cityList: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getHouseFilterType();
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getHouseFilterType: function getHouseFilterType() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getHouseFilterType();
            case 1:
              res = _context2.v;
              _this2.filterList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getAuthRole: function getAuthRole(role) {
      if (role == 1) {
        return "房东";
      } else if (role == 2) {
        return "转租";
      } else if (role == 3) {
        return "商户";
      } else if (role == 5) {
        return "房东家人";
      }
      return "查看";
    },
    goRealName: function goRealName(row) {
      window.open("#/user/real-name?number=".concat(row.auth_info.idcard_number));
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row.user;
      this.remarkDialogVisible = true;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    restoreLandlordAuth: function restoreLandlordAuth(row) {
      var _this3 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.restoreLandlordAuth({
                id: row.id,
                adminId: util.cookies.get("uuid")
              });
            case 1:
              _this3.$message.success("操作成功");
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))).catch(function () {});
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pageNum = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getLandlordAuthList(_this4.searchForm);
            case 1:
              res = _context4.v;
              res.data.content = res.data.content || [];
              res.data.content.forEach(function (item) {
                item.auth_time = item.auth_time ? dayjs(item.auth_time * 1000).format("YYYY-MM-DD HH:mm") : "";
                item.expiration_date = item.expiration_date ? dayjs(item.expiration_date * 1000).format("YYYY-MM-DD HH:mm") : "";
                item.last_login_time = item.last_login_time ? dayjs(item.last_login_time * 1000).format("YYYY-MM-DD HH:mm") : "";
              });
              _this4.tableData = res.data.content;
              _this4.total = res.data.totalSize;
              _this4.tableLoading = false;
              _this4.getUserListByIds(_this4.tableData, "user_id");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};